const INITIAL_STATE = {
  allAverageCostsList: [],
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'SET_ALL_AVERAGE_COSTS': {
      return { ...state, allAverageCostsList: action.allAverageCosts };
    }
    default:
      return state;
  }
};